// Zeya contact form — merges the "Subject" select and optional order number
// into the native contact[body] (Shopify drops unknown contact[] fields).
// Pure logic for tests: fuseContactBody(). DOM wiring runs on load.

export function fuseContactBody(subject, order, body) {
  const bits = [];
  if (subject && !body.startsWith('Sujet :')) bits.push(`Sujet : ${subject}`);
  if (order && !body.includes('Numéro de commande :')) bits.push(`Numéro de commande : ${order}`);
  return bits.length ? `${bits.join(' · ')}\n\n${body}` : body;
}

const bindForm = (form) => {
  const body = form.querySelector('textarea[name="contact[body]"]');
  if (!body || body.dataset.zeyaContactMux === 'true') return;
  body.dataset.zeyaContactMux = 'true';
  form.addEventListener('submit', () => {
    const subject = form.querySelector('.zeya-contact__subject')?.value?.trim();
    const order = form.querySelector('.zeya-contact__order')?.value?.trim();
    body.value = fuseContactBody(subject, order, body.value);
  });
};

export function initZeyaContactForms() {
  document.querySelectorAll('.zeya-contact__form').forEach(bindForm);
}

if (typeof document !== 'undefined') {
  initZeyaContactForms();
}